import HeroDefaultStyle from '@/styles/components/careers/hero-section/_index.module.scss';
import SettingIcon from 'public/icons/career_icons/setting.svg';
import CloseEyeIcon from 'public/icons/career_icons/eye-close.svg';
import OpenEyeIcon from 'public/icons/career_icons/eye-open.svg';
import LinkIcon from 'public/icons/career_icons/link.svg';
import {EditBannerIcon, Header, useEffect} from '@/imports-files/pages/career/customize-career-page';

import { useRef, Button, useState } from '@/imports-files/pages/career/customize-career-page';

export function HeroSection({formik, customizeCareerAction, isPreview, setButtonPopup, resetCareerPage})
{
  const headerTitle = useRef(formik.values.hero_section_attributes.title);
  const button1 = useRef(formik.values.hero_section_attributes.button_hash.buttons[0].text);
  const [buttonIcons, setButtonIcons] = useState([false, false])
  const [flagForRender, setFlagForRender] = useState(0)

  function buttonIconClass(buttonIcons, index){
    return !isPreview ? HeroDefaultStyle.Hero__EditButton__ShowIcons : ''
  }

  function buttonIconParentClass(buttonIcons, index){
    return (!isPreview && buttonIcons[index]) ? HeroDefaultStyle.Hero__EditButton : ''
  }

  function eyeIcons(formik, index){
    return formik.values.hero_section_attributes.button_hash.buttons[index].is_visible ? <OpenEyeIcon/> : <CloseEyeIcon/>
  }

  function imageUrl(formik){
    const image_url = (typeof window !== 'undefined' && window.innerWidth <=600) ? formik.values.hero_section_attributes.mobile_image_url : formik.values.hero_section_attributes.hero_image_url
    return  image_url || "/images/components/customise_career/hero-banner.jpg"
  }

  useEffect(() => {
    headerTitle.current = formik.values.hero_section_attributes.title
    button1.current = formik.values.hero_section_attributes.button_hash.buttons[0].text
    setFlagForRender(Math.random() * 10000)
  }, [resetCareerPage])

  return(
    <div id={"Hero_Back_Image"} className = {`${HeroDefaultStyle.Hero} ${HeroDefaultStyle.Hero__BackgroundImage}`} style={{backgroundImage: `url(${imageUrl(formik)})`}}>

        <div style= {customizeCareerAction.backgroundOverlayValue(formik)} className={`${HeroDefaultStyle.Overlayhero}`}>
        </div>
        {!isPreview && <div className = {`${HeroDefaultStyle.Hero__SettingsIcon}`}  onClick={() => { customizeCareerAction.showHideSidePanel(true) }}>
          <SettingIcon/>
        </div>}
        <div className = {`${isPreview ? HeroDefaultStyle.Hero__PreviewHeroTitle : HeroDefaultStyle.Hero__EditHeroTitle}`}>
            <div className = {`${HeroDefaultStyle.Hero__EditHeroTitle__Contenteditable}`}>
              {isPreview ? <p
                suppressContentEditableWarning={true}
                dangerouslySetInnerHTML={{ __html: headerTitle.current }}
                style={customizeCareerAction.heroTitleStyle(formik)}
              />
              :
               <p
                contentEditable={true}
                onInput={(e)=> {
                  formik.setFieldValue('hero_section_attributes.title', e.currentTarget.innerHTML || '')
                }}
                onPaste={(event)=> {
                  customizeCareerAction.onPastePreventStyling(event)
                }}
                onBlur={(e)=>  {
                  customizeCareerAction.updateHeroSection(formik.values)
                }}
                suppressContentEditableWarning={true}
                dangerouslySetInnerHTML={{ __html: headerTitle.current }}
                style={customizeCareerAction.heroTitleStyle(formik)}
              />}
            </div>

            <div className = {`${HeroDefaultStyle.Hero__TwoButtons}`}>
              <div className = {`${HeroDefaultStyle.Hero__LeftButton} ${buttonIconParentClass(buttonIcons, 0)}`}>
                {!isPreview && <div className = {`${HeroDefaultStyle.Hero__LeftButton__ButtonIconsHide} ${buttonIconClass(buttonIcons, 0)}`}>
                  <span onClick={async(event)=> {
                    await formik.setFieldValue('hero_section_attributes.button_hash.buttons.0.is_visible', !formik.values.hero_section_attributes.button_hash.buttons[0].is_visible)
                    setTimeout(customizeCareerAction.updateHeroSection(formik.values), 1000)
                  }}>{eyeIcons(formik, 0)}</span>
                  <span onClick={(event) => {
                    setButtonPopup({state: true, button_index: 0, sections_list: customizeCareerAction.listOfSections(), formik: formik})
                  }}><LinkIcon/></span>
                </div>}
                {(!isPreview || formik.values.hero_section_attributes.button_hash.buttons[0].is_visible) && <span
                  contentEditable={!isPreview}
                  onInput={(e)=> {
                    let button1_hash = formik.values.hero_section_attributes.button_hash.buttons[0]
                    button1_hash.text = e.currentTarget.textContent
                  }}
                  onPaste={(event)=> {
                    customizeCareerAction.onPastePreventStyling(event)
                  }}
                  onClick={() => {
                    setButtonIcons([true, false])
                    customizeCareerAction.onHeroButtonClick(formik, isPreview, 0)
                  }}
                  onBlur={(e)=>  {
                    setButtonIcons([false, false])
                    customizeCareerAction.updateHeroSection(formik.values)
                  }}
                  suppressContentEditableWarning={true}
                  dangerouslySetInnerHTML={{ __html: button1.current }}
                  className={`${HeroDefaultStyle.Hero__ButtonStyle} ${isPreview ? 'CursorPointer' : ''}`}
                  style={customizeCareerAction.heroButtonStyle(formik)}
                />}
              </div>
              {/* <div className = {`${HeroDefaultStyle.Hero__RightButton} ${buttonIconParentClass(buttonIcons, 1)}`}>
                {!isPreview && <div className = {`${HeroDefaultStyle.Hero__RightButton__ButtonIconsHide} ${buttonIconClass(buttonIcons, 1)}`}>
                  <span onClick={async(event)=> {
                    await formik.setFieldValue('hero_section_attributes.button_hash.buttons.1.is_visible', !formik.values.hero_section_attributes.button_hash.buttons[1].is_visible)
                    setTimeout(customizeCareerAction.updateHeroSection(formik.values), 1000)
                  }}>{eyeIcons(formik, 1)}</span>
                  <span onClick={(event) => {
                    setButtonPopup({state: true, button_index: 1, sections_list: customizeCareerAction.listOfSections(), formik: formik})
                  }}><LinkIcon/></span>
                </div>}
                {(!isPreview || formik.values.hero_section_attributes.button_hash.buttons[1].is_visible) && <span
                  contentEditable={!isPreview}
                  onInput={(e)=> {
                    let button2_hash = formik.values.hero_section_attributes.button_hash.buttons[1]
                    button2_hash.text = e.currentTarget.textContent
                  }}
                  onClick={() => {
                    setButtonIcons([false, true])
                    customizeCareerAction.onHeroButtonClick(formik, isPreview, 1)
                  }}
                  onBlur={(e)=>  {
                    setButtonIcons([false, false])
                    customizeCareerAction.updateHeroSection(formik.values)
                  }}
                  suppressContentEditableWarning={true}
                  dangerouslySetInnerHTML={{ __html: button2.current }}
                  className={`${HeroDefaultStyle.Hero__ButtonStyle} ${isPreview ? 'CursorPointer' : ''}`}
                  style={customizeCareerAction.heroButtonStyle(formik)}
                />}
              </div> */}
          </div>
        </div>
        {!isPreview && <div className={`${HeroDefaultStyle.Hero__EditBannerIcon}`}>
          <input id   =   ""
           accept     =   ".png, .jpg, .jpeg"
           type       =   "file"
           onChange   =   { (event) => customizeCareerAction.handleBackgroundOnChange(event, formik)}
           title      =   {customizeCareerAction.imageInfoContent('hero_image')}
           />
          <EditBannerIcon/>
        </div>}
    </div>
  )
}